import React, { FC } from "react";
import { Routes, Route } from "react-router-dom";
import ReturnProductAppCreate from "./ReturnProductAppCreate";
import ReturnProductAppDetails from "./ReturnProductAppDetails";
import ReturnProductAppList from "./ReturnProductAppList";

const ReturnProductAppPage: FC = () => {
  return (
    <Routes>
      <Route index element={<ReturnProductAppList />} />
      <Route path="new/:sourceType/:orderId" element={<ReturnProductAppCreate />} />
      <Route path=":returnId" element={<ReturnProductAppDetails />} />
    </Routes>
  );
};

export default ReturnProductAppPage;
